import React, { useState, useRef } from "react";
import { Link as ReactLink, useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import { Form, Button, Container, Spinner, Row, Col } from "react-bootstrap";
import { useAuthStore } from "../model";
import { login } from "../api";
import { getUserByToken } from "@/entities/user/api";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { PasswordInputGroup } from "@/shared/ui";
import { useMediaQuery } from "react-responsive";

export const LoginForm = () => {
  const [numberPhone, setNumberPhone] = useState("");
  const [password, setPassword] = useState("");
  const [validated, setValidated] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { setUser, setIsAuthorization } = useAuthStore();
  const buttonRef = useRef<HTMLButtonElement>(null);
  const isMobile = useMediaQuery({maxWidth: 768}) 

  const isValidPhone = (phone: string) => {
    const digits = phone.replace(/\D/g, "");
    return digits.length === 11 && (digits.startsWith("7") || digits.startsWith("8"));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setValidated(true);

    if (!numberPhone || !password) {
      enqueueSnackbar("Пожалуйста, заполните все поля.", { variant: "error" });
      buttonRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }

    if (!isValidPhone(numberPhone)) {
      enqueueSnackbar("Введите корректный номер телефона.", { variant: "error" });
      buttonRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }

    setLoading(true);
    try {
      const data = await login({
        phone: numberPhone.replace(/^7/, "8"),
        password,
      });

      if (data.success) {
        localStorage.setItem("token", data.result);
        setIsAuthorization();
        navigate("/");
        enqueueSnackbar("Успешный вход!", { variant: "success" });

        const me = await getUserByToken(data.result);
        if (me) setUser(me.result);
      }
    } catch (err) {
      console.error(err);
      enqueueSnackbar("Ошибка при входе. Попробуйте позже.", { variant: "error" });
    } finally {
      setLoading(false);
    }
  };

  
  const roundedClass = isMobile ? "rounded-0" : "rounded-4";

  return (
    <Container className="p-0 d-flex align-items-center justify-content-center" style={{ height: "calc(100% - 42px)" }}>
          <div
            className={`${roundedClass} overflow-x-hidden overflow-y-auto shadow-lg`}
            style={{ width: "100%", maxHeight: isMobile ? "100%" : 560, height: "100%",  maxWidth: "900px" }}
          >
            <Row className={`g-0 h-${isMobile ? 25 : 100}`} >
          <Col
            xs={12}
            md={6}
            className="d-flex pt-3 flex-column align-items-center justify-content-center text-white"
            style={{ backgroundColor: "#121218", minHeight: isMobile ? "230px" : "470px" }}
          >
            <img
              src="/logo.webp"
              alt="O!-Chat Logo"
              style={{
                height: `${isMobile ? 120 : 190}px`,
                width: "auto",
                marginBottom: ".5rem",
                objectFit: "contain",
              }}
            />
              <h1 className="o-chat-gradient-text">
    Вход в O!-Chat
  </h1>
          </Col>

          <Col
            xs={12}
            md={6}
            className="d-flex align-items-center justify-content-center"
            style={{  color: "#111", minHeight: "300px" }}
          >
            <div className="w-100" style={{ maxWidth: "360px", padding: "2rem 1.5rem" }}>
              <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <Form.Group controlId="formPhone" className="mb-3">
                  <Form.Label>Номер телефона</Form.Label>
                  <PhoneInput
                    country={"ru"}
                    disableDropdown={true}
                    specialLabel=""
                    masks={{ ru: "(...) ...-..-.." }}
                    onlyCountries={["ru"]}
                    placeholder="Введите номер телефона"
                    value={numberPhone}
                    onChange={(phone) => {
                      if (phone.startsWith("8")) {
                        setNumberPhone(`7${phone.slice(1)}`);
                      } else {
                        setNumberPhone(phone);
                      }
                    }}
                    inputClass="form-control rounded-5 w-100"
                  />
                  {validated && !isValidPhone(numberPhone) && (
                    <div className="text-danger" style={{ fontSize: "0.875em" }}>
                      Введите корректный номер телефона.
                    </div>
                  )}
                </Form.Group>

                <PasswordInputGroup
                  label="Пароль"
                  value={password}
                  name="password"
                  onChange={(e) => setPassword(e.target.value)}
                  showPassword={showPassword}
                  toggleShow={() => setShowPassword(!showPassword)}
                  placeholder="Введите пароль"
                  isInvalid={validated && !password}
                  feedback="Пожалуйста, введите ваш пароль."
                />

                <Button
                  ref={buttonRef}
                  variant="outline-secondary"
                  type="submit"
                  className="w-100 mt-3"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="me-2"
                      />
                      Вход...
                    </>
                  ) : (
                    "Войти"
                  )}
                </Button>

                <div className="text-center mt-3">
                  <ReactLink to="/forgot" className="text-secondary">
                    Забыли пароль?
                  </ReactLink>
                </div>
              </Form>
            </div>
          </Col>
        </Row>
      </div>
    </Container>
  );
};